import React from "react";
import { Flex, Hide, Heading, Show, Button, Image } from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useAuthenticator } from "@aws-amplify/ui-react";

import MainHeader from "./MainHeader";
import NavLinks from "./NavLinks";
import SideDrawer from "./SideDrawer";
import Backdrop from "../UIElements/Backdrop";
import { LARGE_SREEN } from "../../utils/constants";
import { useBooleanState } from "../../utils/useBooleanState";

import "./MainNavigation.css";
import arupRedLogo from "../../assets/arup_red.svg";

const MainNavigation = (props) => {
  const [drawerIsOpen, openDrawer, closeDrawer] = useBooleanState();
  const { user } = useAuthenticator((context) => [context.user]);

  return (
    <React.Fragment>
      {drawerIsOpen && <Backdrop onClick={closeDrawer} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawer}>
        <nav className="main-navigation__drawer-nav">
          <NavLinks />
        </nav>
      </SideDrawer>

      <MainHeader>
        {
          user && (
            <Hide breakpoint={`(min-width: ${LARGE_SREEN}px)`}>
              <Button className="main-navigation__menu-btn" onClick={openDrawer} >
                <HamburgerIcon boxSize={8} />
              </Button>
            </Hide>
          )
        }

        <Flex alignItems="center">
          <Image src={arupRedLogo} height="1.6em" display="inline-block" mt="4px" mr="1em" commit_detials="commit_sha: 5dac71a25d0c84ac749436df83ecea1567f58814 build_time: 2026-10-07T12:21:20+01:00"/>
          <Heading as="h1" display="inline-block">
            ArTY
          </Heading>
        </Flex>
        

        <Show breakpoint={`(min-width: ${LARGE_SREEN}px)`}>
          <NavLinks />
        </Show>
      </MainHeader>
    </React.Fragment>
  );
};

export default MainNavigation;
